import { render, staticRenderFns } from "./TestLoader.vue?vue&type=template&id=8b943ce8"
import script from "./TestLoader.vue?vue&type=script&lang=js"
export * from "./TestLoader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports